import { jsPDF } from 'jspdf';

import { SlideElementIframeType } from '../../components/SlideComponents/slide.types';

const YOUTUBE_PLACEHOLDER = 'External YouTube media';
const DEFAULT_PLACEHOLDER = 'External media';

export const addYoutubePlaceholder = (pdf: jsPDF, element: SlideElementIframeType) => {
  const { x, y, width, height } = element;
  pdf.setFillColor('0.5');
  pdf.setDrawColor('0.8');
  pdf.setTextColor('0.8');
  pdf.setLineWidth(5);
  pdf.setFontSize(30);
  pdf.rect(x, y, width, height, 'FD');
  const textDimensions = pdf.getTextDimensions(DEFAULT_PLACEHOLDER, { maxWidth: width });
  pdf.text(
    YOUTUBE_PLACEHOLDER,
    x + width / 2,
    y + height / 2 - textDimensions.h / 2 + pdf.getFontSize() / 2,
    {
      align: 'center',
      maxWidth: width,
    },
  );
};

export const addDefaultPlaceholder = (pdf: jsPDF, element: SlideElementIframeType) => {
  const { x, y, width, height } = element;
  pdf.setFillColor('0.5');
  pdf.setDrawColor('0.8');
  pdf.setTextColor('0.8');
  pdf.setLineWidth(5);
  pdf.setFontSize(30);
  pdf.rect(x, y, width, height, 'FD');
  const textDimensions = pdf.getTextDimensions(DEFAULT_PLACEHOLDER, { maxWidth: width });
  pdf.text(
    DEFAULT_PLACEHOLDER,
    x + width / 2,
    y + height / 2 - textDimensions.h / 2 + pdf.getFontSize() / 2,
    {
      align: 'center',
      maxWidth: width,
    },
  );
};

export const addIframe = async (pdf: jsPDF, element: SlideElementIframeType) => {
  pdf.saveGraphicsState();
  switch (element.iframeOrigin) {
    case 'youtube':
      addYoutubePlaceholder(pdf, element);
      break;
    default:
      addDefaultPlaceholder(pdf, element);
  }
  pdf.restoreGraphicsState();
};
